import React from 'react';

import Payments from './payments';

import './standalone-payments.scss';

const StandalonePayments = ({ match, history }) => {
  return (
    <div className="standalone-payments">
      <div className="title">Payments</div>
      <div className="content">
        <div>
          <Payments match={match} history={history} />
        </div>
      </div>
    </div>
  );
};

export default StandalonePayments;
